export const BLURRY = {
  color: "transparent",
  textShadow: "0px 0px 8px rgba(0,0,0,0.4)",
};
